(function($) {
    'use strict';

    // Get query parameter from current url
    $.urlParam = function(name) {
        var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (!results) {
            return null;
        }

        return results[1] || 0;
    };

    // Delay the form load as critical css is causing the form to break in Firefox and IE
    $('.form').delay(2000).queue(function(delayblock) {
        $(this).addClass('ShowBlock');
        delayblock();
    });
})(jQuery);
